import { CITIZEN_FIELDS_INITIAL_VALUES } from '../citizens'

export const UNIFIED_PERSON_FIELDS_INITIAL_VALUE = CITIZEN_FIELDS_INITIAL_VALUES
